import { Environment } from './environment.model';

const stopCodesApiBaseUrl = '';
const stopCodesApiPath = '/dotnet/api';

export const environment: Environment = {
  production: false,
  localDev: false,
  stopCodesApiBaseUrl,
  stopCodesApiPath,
  stopCodesScope:
    'https://worksite.onmicrosoft.com/SG_OT_STOP_Webportal_Backend_D/.default',
  tenantId: '67416604-6509-4014-9859-45e709f53d3f',
  clientId: 'ddf9a59c-e4d1-42aa-883b-12a98747075b',
  scope:
    'https://worksite.onmicrosoft.com/SG_OT_STOP_Webportal_Backend_D/.default',
  persistAuthAcrossSessions: true,
  applicationInsights: {
    applicationInsightsConfig: {
      connectionString:
        'InstrumentationKey=0f2a4a29-b176-4f30-a6a7-2675cd85f24e;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=9da7f624-d53f-4b53-a5d0-4abc6e3be8cc',
    },
  },
};
